/**
 * Route configuration
 * Matches legacy DataProtect routes for backwards compatibility
 */
export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  CALLBACK: '/callback',
  REGISTER: '/register',
  DATA_MAPPING: '/datamapping/:mapperGuid',

  // OAuth callback routes (external services redirect here)
  SF_OAUTH: '/sfoauth',
  DS_OAUTH: '/dsoauth',
  BS_OAUTH: '/bsoauth',
  ZOOM_OAUTH: '/zoomOauth',
  CANVAS_OAUTH: '/canvasOauth',

  // Auth verification
  VERIFY: '/verify',

  // Protected routes
  HOME: '/',
  NEW_ACCOUNT: '/newaccount',

  // Account settings routes (with organizations nested under)
  ACCOUNT_SETTINGS: '/account-settings',
  ACCOUNT_THEMES: '/account-settings/themes',
  ORGANIZATIONS: '/account-settings/organizations/:orgId',
  ORG_USERS: '/account-settings/organizations/:orgId/users',
  ORG_PROJECT_USERS: '/account-settings/organizations/:orgId/projects',
  ORG_PROJECT_USERS_DETAIL: '/account-settings/organizations/:orgId/projects/:projectId/users',
  ORG_DPH: '/account-settings/organizations/:orgId/data-processing-hours',

  // Legacy routes (redirect to new structure)
  ADD_USER: '/adduser/:tenantId',
  EDIT_USER: '/edituser',
  RESOURCES: '/resources',
  RECIPE_DEMO: '/recipe/:exampleId',
  INVITATIONS: '/invitations/:feedKey',

  // App routes (main workspace)
  APP: '/a/:appId',
  APP_DETAILS: '/a/:appId/details',
  APP_JOBS: '/a/:appId/jobs',
  APP_EVENTS: '/a/:appId/events',
  APP_SETTINGS: '/a/:appId/settings',
  APP_SCHEDULE: '/a/:appId/schedule',
} as const;

/**
 * Routes that don't require authentication
 */
export const PUBLIC_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.CALLBACK,
  ROUTES.REGISTER,
  ROUTES.DATA_MAPPING,
  ROUTES.SF_OAUTH,
  ROUTES.DS_OAUTH,
  ROUTES.BS_OAUTH,
  ROUTES.ZOOM_OAUTH,
  ROUTES.CANVAS_OAUTH,
  ROUTES.VERIFY,
] as const;
